// extracted by mini-css-extract-plugin
module.exports = {"heading":"Partners_heading__20-FF","container":"Partners_container__3Ql1m","logos":"Partners_logos__1BHw1","partner":"Partners_partner__253ER"};